import React from 'react';
import { Radio as KRadioItem, } from '@ui-kitten/components';
export const Kitten = (props) => {
    // @ts-ignore
    const { style, children, ...rest } = props;
    return (<KRadioItem 
    // @ts-ignore
    style={style} {...rest}>
      {children}
    </KRadioItem>);
};
export default {
    Kitten,
};
//# sourceMappingURL=RadioItem.js.map